import React from "react";

const AssessmentBanner = ({
  title,
  currentIndex,
  totalAssessments,
  isAlreadyUploaded,
  isAllCompleted,
}) => {
  return (
    <div className="common-banner-block height-diff-assement">
      <div className="main-banner ">
        <img src="/images/banner-common-block.png" alt="Assessment banner" />
      </div>
      <div className="container">
        <div className="common-banner-block-inner ">
          <h1>{title || "Assessment"}</h1>
          <p>
            ({currentIndex + 1}/{totalAssessments})
          </p>
          <p
            className="uploaded-indicator"
            style={{ color: "#28a745", fontSize: "14px" }}
            hidden={!isAlreadyUploaded}
          >
            ✓ Previously uploaded
          </p>
          <div
            style={{
              marginTop: "1rem",
              textAlign: "center",
              fontSize: "22px",
              color: "#28a745",
            }}
            hidden={!isAllCompleted}
          >
            ✓ All assessments are completed. Thank you!
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssessmentBanner;
